/*
 * Device 中的属性会带到 http 请求中，请谨慎修改此文件
 */
import getDeviceId from '@tiger/device-id';
import { getWebOS } from '@tiger/utils/userAgent';
import pkg from 'package.json';
import { language } from 'utils/i18n';

const ua = navigator.userAgent;

class Device {
    constructor(isTiger) {
        this.platform = isTiger ? 'h5' : 'web';
    }

    deviceId: string = getDeviceId();
    appVer = pkg.version.split('-')[0].replace(/[a-zA-Z]/g, '');
    vendor = 'web';
    lang = language;
    platform: 'h5' | 'web';
    os = getWebOS();
    isIOS = !!ua.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
    isAndroid = /Android/i.test(ua);
}

export default Device;
